import React from "react";
import { ButtonProps, Button } from "@campgladiator/cgui-core.atoms.button";
import { PaginationProps } from "../../";

type EndCapProps = {
  direction: "back" | "forward";
  disabled?: ButtonProps["disabled"];
  onClick: () => void;
  size: PaginationProps["size"];
};

const EndCap = ({ size, disabled, onClick, direction }: EndCapProps) => {
  const arrow: ButtonProps["icon"] =
    direction === "back"
      ? { name: "icon-angle-left", type: "solid" }
      : { name: "icon-angle-right", type: "solid" };
  return (
    <Button
      size={size}
      emphasis="secondary-alt"
      variation="outline"
      disabled={disabled}
      icon={arrow}
      onClick={onClick}
    />
  );
};

export default EndCap;
